import { types, applySnapshot } from "mobx-state-tree";
import { Framework } from "@flint/framework";

const TopicModel = types
  .model("TopicModel", {
    id: types.string,
    isbn: types.string,
    topicTitle: types.string,
    specialty: types.string,
    isFree: types.boolean,
    top3: types.boolean,
    genusMaster: types.array(
      types.model({
        id: types.string,
        genus: types.string,
      })
    ),
    specialityMaster: types.array(
      types.model({
        id: types.string,
        speciality: types.string,
      })
    ),
    genus: types.array(types.string),
  })
  .actions((self) => ({
    fetch(ID) {
      Framework.sendEvent("FETCHING_TOPIC_DATA", {ID});
    },
    set(response) {
      const data = response.data.response;
      applySnapshot(self, {
        id: data.id,
        isbn: data.isbn,
        topicTitle: data.topicTitle,
        specialty: data.specialty,
        isFree: data.isFree,
        top3: data.top3,
        genusMaster: data.genusMaster,
        specialityMaster: data.specialityMaster,
        genus: data.genus,
      });
    },
  }));

export default TopicModel;
